import { svgToPng, drawWatermark } from "./exportPng";

const S = 1080, PAD = 48, TOP = 200, BOTTOM = 96, RATIO = 650 / 406;
export const isFinished = (p) => !!(p.design?.photo?.file && p.design?.player?.name?.trim());

const loadImg = (src) => new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });

// Picks the column count that gives the biggest shield for n cards in the grid area.
const bestGrid = (n, w, h, gap) => {
  let best = { cols: 1, cw: 0 };
  for (let cols = 1; cols <= n; cols++) {
    const rows = Math.ceil(n / cols);
    const cw = Math.min((w - gap * (cols - 1)) / cols, ((h - gap * (rows - 1)) / rows) / RATIO);
    if (cw > best.cw) best = { cols, cw };
  }
  return best;
};

const fitText = (ctx, text, max, size, weight) => {
  let s = size;
  do { ctx.font = `${weight} ${s}px Outfit, sans-serif`; s -= 2; } while (ctx.measureText(text).width > max && s > 20);
};

export async function squadPoster(svgs, { club, squad }) {
  const c = document.createElement("canvas");
  c.width = c.height = S;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#0f172a";
  ctx.fillRect(0, 0, S, S);
  ctx.fillStyle = "#a3e635";
  for (let x = -40; x < S; x += 40) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x + 20, 0); ctx.lineTo(x + 32, 12); ctx.lineTo(x + 12, 12); ctx.fill(); }
  ctx.textBaseline = "alphabetic";
  ctx.fillStyle = "#a3e635";
  ctx.font = "800 26px Outfit, sans-serif";
  if (club) ctx.fillText(club.toUpperCase(), PAD, 82);
  ctx.fillStyle = "#ffffff";
  fitText(ctx, (squad || "Squad").toUpperCase(), S - PAD * 2, 84, 900);
  ctx.fillText((squad || "Squad").toUpperCase(), PAD, 160);

  const pngs = await Promise.all(svgs.map((svg) => svgToPng(svg, { scale: 1.5, watermark: false })));
  const imgs = await Promise.all(pngs.map((b) => loadImg(URL.createObjectURL(b))));
  const gap = 18, gw = S - PAD * 2, gh = S - TOP - BOTTOM;
  const { cols, cw } = bestGrid(imgs.length, gw, gh, gap);
  const ch = cw * RATIO, rows = Math.ceil(imgs.length / cols);
  const y0 = TOP + (gh - (rows * ch + (rows - 1) * gap)) / 2;
  imgs.forEach((img, i) => {
    const r = Math.floor(i / cols), inRow = Math.min(cols, imgs.length - r * cols);
    const x0 = PAD + (gw - (inRow * cw + (inRow - 1) * gap)) / 2;
    ctx.drawImage(img, x0 + (i % cols) * (cw + gap), y0 + r * (ch + gap), cw, ch);
    URL.revokeObjectURL(img.src);
  });

  try { const logo = await loadImg("/img/logo-mark.png"); const lh = 52; ctx.drawImage(logo, PAD, S - 28 - lh, (logo.width / logo.height) * lh, lh); } catch { /* logo optional */ }
  ctx.fillStyle = "#cbd5e1";
  ctx.font = "700 22px Outfit, sans-serif";
  ctx.textAlign = "right";
  ctx.fillText("Design yours at sportsshields.ie", S - PAD, S - 42);
  ctx.textAlign = "left";
  ctx.fillStyle = "#ffffff";
  ctx.font = "900 26px Outfit, sans-serif";
  ctx.fillText("sportsshields.ie", PAD + 64, S - 42);
  drawWatermark(ctx, S, S, { div: 30, alpha: 0.55 });
  return new Promise((res) => c.toBlob(res, "image/png"));
}
